import React, {Component} from 'react';
import Speaker from "./SpeakerInfo"
import {Grid, Row, Col} from 'react-bootstrap';


class SpeakersList extends Component {
    render() {
        return (
            <Grid>
                <Row>
                    {this.props.speakers.map(speaker => (
                        <Col xs={12} sm={6} lg={4} key={speaker.id}>
                            <Speaker speaker={speaker}/>
                        </Col>
                    ))}
                </Row>
            </Grid>
        );
    }
}


export default SpeakersList;




// WEBPACK FOOTER //
// ./src/components/speakers/SpeakersList.js